var map = {
	"./arrowdown.svg": "22a7",
	"./binance-coin-bnb-logo.svg": "5d8a",
	"./copy.svg": "553b",
	"./ethereum-eth-logo.svg": "a8b0",
	"./github.svg": "387e",
	"./info.svg": "07e6",
	"./logo-topleft.svg": "3314",
	"./metamask-fox.svg": "9564",
	"./metamask-logo-horizontal.svg": "6ba3",
	"./pixel.png": "2cca",
	"./polygon-matic-logo.svg": "cce8",
	"./telegram.svg": "7dd3",
	"./twitter.svg": "a3df",
	"./warning.svg": "afb7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";